import api from "@/api";
export const state = {
  currentUser: localStorage.getItem("authUser"),
  userId: localStorage.getItem("userId"),
};

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue;
    saveState("authUser", newValue);
  },
  SET_USER_ID(state, newValue) {
    state.currentUserId = newValue;
    saveState("userId", newValue);
  },
};

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser;
  },
  user(state) {
    return state.currentUser;
  },
};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {
    dispatch("validate");
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { email, password } = {}) {
    if (getters.loggedIn) return dispatch("validate");
    return api.auth.loginCRM(email, password).then(() => {
      commit("SET_CURRENT_USER", true);
      return true;
    });
  },

  // Logs out the current user.
  logOut({ commit }) {
    // eslint-disable-next-line no-unused-vars
    commit("SET_CURRENT_USER", "");
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-unused-vars
      api.auth
        .logoutCRM()
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(this._handleError(error));
        });
    });
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  // eslint-disable-next-line no-unused-vars
  validate({ commit, state }) {
    if (!state.currentUser) return Promise.resolve(null);
    return api.auth.validate().then((response) => {
      commit("SET_CURRENT_USER", response);
      return response;
    });
  },
};

// ===
// Private helpers
// ===

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state));
}
